import {connect} from "react-redux";
import {SingleFacilityDropdownSelect} from "../../pages/page-admin-facility-settings/atoms/facility-settings-header/SingleFacilityDropdownSelect";
import {AppState, select} from "../../store/store";
import {FacilityDropdownTreeSelect} from "../facility-dropdown-tree-select";

import {DataNode} from "rc-tree/lib/interface";
import {Facilities} from "../../models/types/AdmissionForm";
import {useHistory} from "react-router-dom";
import {useFacilitySettingsParams} from "../../pages/page-admin-facility-settings/hooks";
import {FacilityFilterWrapper} from "./styles";
import {Icon} from "@reside/ui";

export const FacilityFilterRenderer = ({
  facilities,
  facilitiesTree,
}: {
  facilities: Facilities;
  facilitiesTree: DataNode[];
}) => {
  const {facilityId} = useFacilitySettingsParams();
  // Check if current tab is facility-settings
  const isFacilitySettings = /facility-settings/.exec(window.location.pathname);
  const isActivityLog = /activity-log/.exec(window.location.pathname);

  const history = useHistory();

  const setFacilityId = (facilityId: string) =>
    history.push(`/admin/facility/${facilityId}/facility-settings`);

  const facility = facilities?.find(facility => facility.id === facilityId);

  const activeId = facility?.id || facilitiesTree[0]?.children[0]?.key;

  return (
    <FacilityFilterWrapper>
      <Icon name="building" />
      {isFacilitySettings || isActivityLog ? (
        <SingleFacilityDropdownSelect
          facilitiesTree={facilitiesTree}
          activeId={activeId}
          onChange={setFacilityId}
          disabled={Boolean(isActivityLog)}
        />
      ) : (
        <FacilityDropdownTreeSelect withoutFacilityName />
      )}
    </FacilityFilterWrapper>
  );
};

export const FacilityFilter = connect((state: AppState) => ({
  facilities: select.adminSession.facilities(state),
  facilitiesTree: select.adminSession.facilitiesTree(state),
}))(FacilityFilterRenderer);
